import { MapNotFoundError } from "@dailywars/core/errors";
import { redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import { restartRunInputSchema, submitTurnInputSchema } from "#/lib/serverInputSchemas";
import { loadMapMedalThresholds } from "#/server/game/mapMedalThresholds.server";
import { createFreshRun, startMapRun } from "#/server/game/startRunCore";

import type { StartRunResponse, SubmitTurnResponse } from "./contracts";
import { executeSubmitTurn } from "./submitTurnCore";

function redirectOnMapNotFound(error: unknown): never {
  if (error instanceof MapNotFoundError) {
    throw redirect({ href: "/" });
  }
  throw error;
}

export const submitTurn = createServerFn({ method: "POST" })
  .validator(submitTurnInputSchema)
  .handler(async ({ data }): Promise<SubmitTurnResponse> => {
    return executeSubmitTurn(data);
  });

export const startMapRunFn = createServerFn({ method: "POST" })
  .validator(restartRunInputSchema)
  .handler(async ({ data }) => {
    try {
      const run = await startMapRun(data);
      const medalThresholds = await loadMapMedalThresholds(data.mapId);
      return { ...run, medalThresholds };
    } catch (error) {
      redirectOnMapNotFound(error);
    }
  });

export const restartRun = createServerFn({ method: "POST" })
  .validator(restartRunInputSchema)
  .handler(async ({ data }): Promise<StartRunResponse> => {
    try {
      return await createFreshRun(data);
    } catch (error) {
      redirectOnMapNotFound(error);
    }
  });
